import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { Event }                                        from 'Domain/Models';

export const getEvents = (state: TRootState, filter: null | IFilterProps<Event> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'id', order: 'ASC' } }) as IFilterProps<Event>;
  }

  return filterObjectStore(state.event.entries, filter);
};
